<script>
import Layout from "../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Area from "@/components/c-input-area";
// import Dropzone from "@/components/c-dropzone";
import Select from "@/components/c-select";
import Search from "@/components/c-select-search";
import { incomeService } from "../../../../services/managements/incomes/income.service";
import { propertyService } from "../../../../services/propertyservice/property.service";
import { servicehelpers } from "../../../../services/servicehelpers";

import i18n from "../../../../i18n";
import Loading from "@/components/c-loading";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "income Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading, 
    Button,
    Input,
    Select,
    Search,
    Area
  },
  data() {
    return {
      dropdownSelection: {},
   
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "income",
      breadCrumb: {},

      incomeData: null,
      projectData: {},
      propertyData: {},
      property: {},
      propertySelected: {},
      categoryData: {},

      dataProject: 0,
      dataLastProject: 0,
      dataReference: '',
      dataProperty: 0,
      dataAmount: 0,
      dataCashAmount: 0,
      dataBankAmount: 0,
      dataChequeAmount: 0,
      dataincomeDate: this.$moment().clone().format('YYYY-MM-DD'),
      dataNotation: '',
      dataName: '',
      dataincomeCategoryId: 0,

      dataCreatedBy: JSON.parse(localStorage.getItem('user'))
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;

    // console.log("AAA", this.dataSeller);

    this.dataSchedule = [];

    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else if('propertyid' in this.$route.query) {
      this.loadingPropertyById(this.$route.query.propertyid);
    } else {
      this.loadingData(0);     
    }
  },
  watch: {
      dataDiscount: function() { // watch it
        // console.log(newVal);
        // this.changeSellPrice();
      }
  },
  methods: {
    loadingData: function(id) {
      this.fetchingStats = true;
      incomeService.getOne(id)
        .then(response => {
            // this.breadCrumb = {
            //   text: response.data.name + " - (" + response.data.code + ")",
            //   active: true,
            // };
          if(id != 0){
            this.incomeData = response;
            this.dataProject = this.incomeData.data.project_id;
            this.dataProperty = this.incomeData.data.property_id;
            this.propertySelected = this.incomeData.data.property_id;
            this.dataReference = this.incomeData.data.code;
            this.dataAmount = this.incomeData.data.amount;
            this.dataCashAmount = this.incomeData.data.cash_amount;
            this.dataBankAmount = this.incomeData.data.bank_amount;
            this.dataChequeAmount = this.incomeData.data.cheque_amount;
            this.dataDate = this.incomeData.data.income_date;
            this.dataName = this.incomeData.data.name;
            this.dataNotation = this.incomeData.data.notation;
            this.dataincomeCategoryId = this.incomeData.data.income_category_id;
            this.dataincomeDate = this.incomeData.data.income_date;
          }
          

          // console.log(response)
          this.loadingSettings(response.setting);
        });

    },


    loadingCurrencyData: function() {
      servicehelpers.getCurrencyData().then(response => {
        this.currencyData = response;
      });
    },

    loadingPropertyById: function(id) {

      this.fetchingStats = false;
      propertyService.getOne(id)
        .then(response => {
          this.fetchingStats = true;
          this.propertySelected = response.data;
          this.dataProperty = this.propertySelected.id;
          this.loadingSettings(response.setting);
        });
    },

    loadingPropertyData: function(projectId = 0) {
      propertyService.getDropdowns(projectId).then(response => {
        this.propertyData = response;
      });
    },


    loadingSettings: function(setting) {
      //paymentmethods
      this.projectData = {data: setting.projects};
      this.propertyData = {data: setting.properties};
      this.categoryData = { data: setting.manageincomecategories};
    },

    submitCancel: function() {

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-income"
          });

        }
      });
    
    },
    submitSave: function() {
      
      this.tryingToSubmit = true;

      let income = {
        ref_no: this.dataReference,
        amount: this.dataAmount,
        bank_amount: this.dataBankAmount,
        cash_amount: this.dataCashAmount,
        cheque_amount: this.dataChequeAmount,
        name: this.dataName,
        notation: this.dataNotation,
        income_date: this.dataincomeDate,
        property_id: this.dataProperty,
        income_category_id: this.dataincomeCategoryId,
        created_by: this.dataCreatedBy.id
       
      };

      // console.log(JSON.stringify(income));

      if(this.isAdd) {
        incomeService.insert(income)
         .then(response => {
           this.tryingToSubmit = false;

           if(response.status == 200) {
              this.$router.push(this.$route.query.redirectFrom || {
                name: "manage-income"
              });
           }else{
             console.log(response)
           }
          
        });
      } else {

        incomeService.update(this.$route.params.id, income)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "manage-income"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },


    clearForm: function() {

      this.dataProperty = 0;
      this.dataCurrency = 0;
      this.dataAmount = 0;

    },

    projectChanged: function(event) {

      this.project = event;
      if(this.dataLastProject != 0) {
        this.loadingPropertyData(this.project);
      }

      this.dataLastProject = event;
    },

    propertyChanged: function(property) {
      this.loadingPropertyById(property.id);      
    },
  },
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('income.text'),
        href: '/general/sale',
      }, {
        text: $t('income.add'),
        active: true
      }]" :title="this.isAdd ? $t('income.add') : $t('income.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('income.text'),
        href: '/general/sale',
      }, this.breadCrumb]" :title="this.isAdd ? $t('income.add') : $t('income.edit')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              
            <div class="row">
                <div class="col-md-4">
                <Select
                  @change="projectChanged" 
                  :id="'project_id'"
                  :editable="false"
                  v-model="dataProject"
                  :list="this.projectData"
                  :label="'property.project'"
                  :require="true"
                    /> 
              </div>
              <div class="col-lg-4">
                <Search 
                  :id="'property_id'"
                  :editable="true"
                  v-model="dataProperty"
                  :list="this.propertyData"
                  :require="true"
                  :label="'property.text'" 
                />
                
              </div>
               <div class="col-lg-4">
                <Input 
                  :type="'text'"
                  :id="'ref_no'"
                  v-model="dataReference"
                  :label="'income.ref_no'"  />
              </div>

            </div>
            <div class="row">
           
              <div class="col-md-4">
                <Input 
                  :type="'date'"
                  :id="'income_date'"
                  v-model="dataincomeDate"
                  :label="'income.date'"  />
              </div>

              
              <div class="col-md-8">
                <Select
                  :id="'project_id'"
                  :editable="false"
                  v-model="dataincomeCategoryId"
                  :list="this.categoryData"
                  :label="'manage.income-category.text'"
                  :require="true"
                    /> 
              </div>
            </div>
            
            <div class="row">
              <div class="col-sm-4">
                <Input 
                  :type="'text'"
                  :id="'amount'"
                  v-model="dataAmount"
                  :label="'income.amount'"  />

                <Input 
                  :type="'text'"
                  :id="'cash_amount'"
                  v-model="dataCashAmount"
                  :label="'ជាសាច់ប្រាក់'"  />

                  <Input 
                  :type="'text'"
                  :id="'bank_amount'"
                  v-model="dataBankAmount"
                  :label="'តាមធនាគារ'"  />

                  <Input 
                  :type="'text'"
                  :id="'cheque_amount'"
                  v-model="dataChequeAmount"
                  :label="'តាមសែក'"  />
              </div>
              <div class="col-sm-8">
                <Area 
                  :rows="13"
                  :id="'notation'"
                  v-model="dataNotation"
                  :label="'booking.notation'"  />
              </div>
            </div>
            <br><br>
            <div class="row">
              <div class="col-lg-12">

                <div inline class="row gy-2 gx-3 align-items-end">
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-x-circle'" 
                      v-bind:buttonType="'button'"
                      v-bind:variant="'danger'"
                      @click="submitCancel()"
                      v-bind:title="$t('general.cancel')"  />
                  </div>
                  <div class="col-sm-auto">
                    <Button v-bind:icon="'bx bx-save bx-tada'" 
                      v-bind:buttonType="'button'"
                      @click="submitSave()"
                      v-bind:requesting="tryingToSubmit"
                      v-bind:title="$t('general.save')"  />
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </div>
      </div>

    </b-form> 
  </Layout>
</template>